import ModulLiveClassTeacher from "@/modules/live_class_teacher/components/LiveClassTeacher";
import ModulLiveClassTeacherDetail from "@/modules/live_class_teacher/components/LiveClassTeacherDetail";

export default [
    {
        path: "/live-class-teacher",
        name: "LiveClassTeacher",
        component: ModulLiveClassTeacher,
    },
    {
        path: "/live-class-teacher-detail",
        name: "LiveClassTeacherDetail",
        component: ModulLiveClassTeacherDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/live_class_teacher/router/liveclassteacher.js